export default __webpack_public_path__ + "static/media/favorite-icon.1e5d8e59.svg";